import {
  DueDate,
  DueDateFromJSON,
  LendUserMessage,
  LendUserMessageFromJSON,
  ReceiveWaitingCollection,
  ReceiveWaitingCollectionFromJSON,
  User,
  UserFromJSON,
  defaultUser,
  exists
} from '@/api'

export interface LendUserInfo {
  user: User
  receiveWaitingCollections: ReceiveWaitingCollection[]
  messages: LendUserMessage[]
  dueDate: DueDate[]
  displayReceiptOutput: string // 0: 非表示, 1: デフォルトON, 2: デフォルトOFF
}

export const defaultLendUserInfo = (): LendUserInfo => ({
  user: defaultUser(),
  receiveWaitingCollections: [],
  messages: [],
  dueDate: [],
  displayReceiptOutput: '0'
})

export function LendUserInfoFromJSON(json: any): LendUserInfo {
  return {
    user: UserFromJSON(json.user),
    receiveWaitingCollections: (json.receive_waiting_collections as any[]).map(
      ReceiveWaitingCollectionFromJSON
    ),
    messages: (json.messages as any[]).map(LendUserMessageFromJSON),
    dueDate: (json.due_date as any[]).map(DueDateFromJSON),
    displayReceiptOutput: exists(json, 'display_receipt_output')
      ? json.display_receipt_output
      : '0'
  }
}
